(function () {
    'use strict';

    angular.module('app')
        .factory('RoleService', RoleService);

    /* @ngInject */
    function RoleService($resource) {
        return $resource('api/admin/role', {}, {
            'get': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();
